<template>
  <keep-alive :include="cachedNames">
    <router-view />
  </keep-alive>
</template>

<script>
export default {
  name: 'KeepAliveView',
  computed: {
    cachedNames() {
      return this.$store.getters.cachedComponentNames
    }
  }
}
</script>
